import { render } from "./SmsComposer.vue?vue&type=template&id=094a05e0"
import script from "./SmsComposer.vue?vue&type=script&lang=js"
export * from "./SmsComposer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__